import { takeLatest, call, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import request from '../../Utils/Request';
import {
  loginUpdate,
  logoutUpdate,
  enableLoader,
  showMessageToast,
} from './Login.reducer';

export const loginUser = createAction('LOGIN_USER');
export const getRefreshToken = createAction('REFRESH_TOKEN');
export const fetchUserDetails = createAction('GET_USER_DETAILS');
export const licenseValidate = createAction('VALIDATE_LICENSE');
export const licenseUpdate = createAction('UPDATE_LICENSE_KEY');

const modelDetails = {
  modelId: 1,
  modelName: 'Test 123',
  type: 'Supervised',
};

function* login(action) {
  try {
    yield put(enableLoader(true));
    const { data, remember } = action.payload;
    const response = yield call(request, '/rest/users/login', {
      data,
      remember,
      action,
    });
    if (response.status === 200) {
      yield put(loginUpdate(response.entity));
      yield put(push('/model-list'));
    }
    yield put(enableLoader(false));
  } catch (error) {
    yield put(enableLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Login Unsuccessful',
        type: 'error',
      })
    );
    console.log(error);
  }
}
function* refreshToken(action) {
  try {
    const { callback } = action.payload;
    const response = yield call(request, '/rest/user/refreshAccessToken', {
      action,
    });
    if (response.status === 200) {
      callback();
    }
  } catch (error) {
    yield put(
      showMessageToast({
        show: true,
        message: error.message
          ? error.message
          : 'Refreshing token unsuccessful!',
        type: 'error',
      })
    );
  }
}
function* getUserDetails(action) {
  try {
    const response = yield call(request, '/rest/users/fetchUserProfile', {
      action,
    });
    if (response.status === 200) {
      yield put(loginUpdate(response.entity));
    }
  } catch (error) {
    yield put(
      showMessageToast({
        show: true,
        message: error.message
          ? error.message
          : 'Fetching user profile unsuccessful',
        type: 'error',
      })
    );
  }
}
function* validateLicense(action) {
  try {
    const { callback } = action.payload;
    const response = yield call(
      request,
      '/rest/license/isLicenseVerifiedAndValid',
      {
        action,
      }
    );
    if (response.status === 200) {
      if (callback) {
        callback(response.entity);
      }
    }
  } catch (error) {
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'License check unsuccessful!',
        type: 'error',
      })
    );
  }
}
function* updateLicenseKey(action) {
  try {
    yield put(enableLoader(true));
    const { data, callback } = action.payload;
    const response = yield call(request, '/rest/license/verify', {
      data,
      action,
    });
    if (response.status === 200) {
      if (callback) {
        callback();
      }
    }
    yield put(enableLoader(false));
  } catch (error) {
    yield put(enableLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'License update unsuccessful!',
        type: 'error',
      })
    );
  }
}

export default function* loginSaga() {
  const watcher = [];
  watcher.push(yield takeLatest(loginUser.toString(), login));
  watcher.push(yield takeLatest(getRefreshToken.toString(), refreshToken));
  watcher.push(yield takeLatest(fetchUserDetails.toString(), getUserDetails));
  watcher.push(yield takeLatest(licenseValidate.toString(), validateLicense));
  watcher.push(yield takeLatest(licenseUpdate.toString(), updateLicenseKey));
}
